import { FC } from "react";
import parse from "html-react-parser";

import classes from "./Button.module.css";

interface Props {
  label: string;
  href?: string;
  secondary?: boolean;
  del?: boolean;
  disabled?: boolean;
  cancel?: boolean;
  small?: boolean;
  important?: boolean;
  shimmer?: boolean;
  onClick?: () => void;
}

const Button: FC<Props> = ({
  label,
  href,
  secondary = false,
  del = false,
  disabled = false,
  cancel = false,
  small = false,
  important = false,
  shimmer = false,
  onClick,
}) => {
  return (
    <a
      onClick={onClick}
      className={`${classes.button} ${secondary ? classes.secondary : ""} ${
        del ? classes.delete : ""
      } ${cancel ? classes.cancel : ""} ${small ? classes.small : ""} ${
        shimmer ? classes.shimmer : ""
      } ${important ? classes.important : ""} ${
        disabled ? classes.disabled : ""
      }`}
      href={href}
    >
      <span>{parse(label)}</span>
    </a>
  );
};

export default Button;
